import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { DeleteLabelDefinition, DeleteLabelDefinitionVariables } from 'types/graphql';
import LabelsApi from './Labels.api';

export function useDeleteLabelDefinition(
  options?: MutationHookOptions<DeleteLabelDefinition, DeleteLabelDefinitionVariables>
) {
  const [mutate, { loading, error }] = useMutation<DeleteLabelDefinition, DeleteLabelDefinitionVariables>(
    LabelsApi.DeleteLabelDefinition,
    options
  );
  const remove = useCallback((id: number) => mutate({ variables: { id } }), [mutate]);
  return { remove, loading, error };
}
